module.exports = __webpack_public_path__ + "img/angry.7d920a41.svg";